/*
 * @Author: Wang_jun 1433207604@qq.com
 * @Date: 2022-03-02 15:28:27
 * @LastEditors: Wang_jun 1433207604@qq.com
 * @LastEditTime: 2023-05-05 19:45:29
 * @FilePath: /visaai-platform/src/utils/translators.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import moment from 'moment'

export const translateToEmpty = value => value || '--'

export const translateToDate = value => value ? moment(value).format('YYYY-MM-DD') : '--'

export const translateToYuan = value => !Number.isNaN(value) ? (Number(value) / 100).toFixed(2) : 0

export const translateByDict = (value, dict, labelKey, valueKey) => {
  if ((value || value === 0) && Array.isArray(dict)) {
    console.log(value, dict, labelKey, valueKey,'data')

    const data = dict.find(item => {
      return item[labelKey] == value
    })
    return data ? data[valueKey] : '--'
  } else {
    return '--'
  }
}
